import React, { PureComponent } from "react";
import {
  withStyles,
  Typography,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
} from "@material-ui/core";
import ProductInfoForm from "../../containers/form/ProductInfoForm";
import ProductPriceForm from "../../containers/form/ProductPriceForm";
import ProductDescriptionForm from "../../containers/form/ProductDescriptionForm";
import ProductDiscountList from "../discount/ProductDiscountList";
import ProductArticleList from "./ProductArticleList";
import ProductImageList from "./ProductImageList";
import ProductStockChart from "./ProductStockChart";

const styles = () => ({
  tabContent: {
    padding: 24,
    minWidth: "300px",
  },
  explanation: {
    marginBottom: "2rem",
  },
});

const TabContainer = (props) => {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
};

class ProductDetail extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tabOpened: 0,
      currentFormIsPristine: true,
      dialogOpen: false,
    };
  }

  handleTabChange = (event, tabOpened, forceChange) => {
    const { currentFormIsPristine } = this.state;
    if (!!currentFormIsPristine || forceChange) {
      //forceChange shouldn't be useful but currentFormIsPristine should be true when going through saveAndChangeTab and it sticks to false
      this.setState({
        tabOpened,
      });
    } else {
      this.handleDialogOpen(tabOpened);
    }
  };

  discardAndChangeTab = async () => {
    const { tabAsked } = this.state;
    await this.setState({ currentFormIsPristine: true });
    this.handleTabChange(null, tabAsked);
    this.handleDialogClose();
  };

  saveAndChangeTab = async () => {
    const { tabAsked, tabOpened } = this.state;
    const formNames = [
      "productInfoForm",
      "productDescriptionForm",
      "productPriceForm",
      "",
      "productArticleForm",
      "productImageForm",
    ];
    document
      .getElementById(formNames[tabOpened])
      .dispatchEvent(new Event("submit", { cancelable: true }));
    await this.setState({ currentFormIsPristine: true });
    this.handleTabChange(null, tabAsked, true);
    this.handleDialogClose();
  };

  handleDialogOpen = (tabAsked) => {
    this.setState({ dialogOpen: true, tabAsked });
  };

  handleDialogClose = () => {
    this.setState({ dialogOpen: false });
  };

  setNewFormState = (pristineState) => {
    this.setState({
      currentFormIsPristine: pristineState,
    });
  };

  render() {
    const { classes, productCode, readOnly, userRole } = this.props;
    const { tabOpened, dialogOpen } = this.state;
    const stockTabDisabled = userRole === "commercial";
    return (
      <>
        <Tabs
          value={tabOpened}
          indicatorColor="primary"
          textColor="primary"
          onChange={this.handleTabChange}
        >
          <Tab label="informations" />
          <Tab label="description" />
          <Tab label="prix" />
          {!stockTabDisabled && <Tab label="quantité" />}
          <Tab label="remises" />
          <Tab label="articles" />
          <Tab label="images" />
        </Tabs>
        {tabOpened === 0 && (
          <TabContainer>
            <ProductInfoForm
              productCode={productCode}
              onFormChange={this.setNewFormState}
              readOnly={readOnly}
            />
          </TabContainer>
        )}
        {tabOpened === 1 && (
          <TabContainer>
            <ProductDescriptionForm
              productCode={productCode}
              onFormChange={this.setNewFormState}
              readOnly={readOnly}
            />
          </TabContainer>
        )}
        {tabOpened === 2 && (
          <TabContainer>
            <ProductPriceForm
              productCode={productCode}
              onFormChange={this.setNewFormState}
              readOnly={readOnly}
            />
          </TabContainer>
        )}
        {tabOpened === 3 && !stockTabDisabled && (
          <TabContainer>
            <ProductStockChart productId={productCode} showNegativeQuantities />
          </TabContainer>
        )}
        {tabOpened === 34 && (
          <TabContainer>
            <Typography variant="body2" className={classes.explanation}>
              Vous trouverez ci-dessous toutes les remises qui concernent le
              produit {productCode}, que ce soit par rapport à son code produit,
              sa marque, son catalogue, etc....
              <br />
              Ces remises sont modifiables dans la section "Remises".
            </Typography>

            <ProductDiscountList
              editable={false}
              addable={false}
              productCode={productCode}
            />
          </TabContainer>
        )}
        {tabOpened === 5 && (
          <TabContainer>
            <ProductArticleList
              productCode={productCode}
              onFormChange={this.setNewFormState}
            />
          </TabContainer>
        )}
        {tabOpened === 6 && (
          <TabContainer>
            <ProductImageList
              productCode={productCode}
              onFormChange={this.setNewFormState}
            />
          </TabContainer>
        )}

        <Dialog
          open={dialogOpen}
          onClose={this.handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Enregistrer les changements ?
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Au changement d'onglet vous perdez toutes les modifications
              apportées. Souhaitez-vous enregistrer les changements ?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.saveAndChangeTab()} color="primary">
              Oui
            </Button>
            <Button
              onClick={() => this.discardAndChangeTab()}
              color="primary"
              autoFocus
            >
              Non
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default withStyles(styles)(ProductDetail);
